import { Box } from "@mui/system";
import { IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { formatBytes } from "../../../helper/converters";
import { IFiles, IItemFile } from "../../../config/interfaces";

import './index.scss'
const ItemFile = (props: IItemFile) => {
  const { file, styles, removeFile, preview, isSelected } = props;

  //Future feature
  const openFile = (file: IFiles) => {
    const url = file.link_url ? file.link_url : file.file;
    if (url) window.open(`https://${url}`, "_blank", "noopener,noreferrer");
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          borderStyle: "solid",
          borderColor: isSelected ? "#FEB100" : "#E5E5E5",
          borderRadius: "9px",
          opacity: 1,
          padding: "1em",
          margin: "0.7em 0",
          backgroundColor: styles?.backgroundColor
            ? styles.backgroundColor
            : "transparent",
          borderWidth: 1,
        }}
        aria-haspopup="true"
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <img src="https://cinemahive.s3.amazonaws.com/images/locations/Group+71518.svg" />
          <Box
            sx={{
              overflow: 'hidden',
              width: '100%'
            }}
          >
            <Typography
              component="p"
              variant="h5"
            >
              {file.name ? file.name : file.file_name}
            </Typography>
            <Typography
              component="p"
              variant="body2"
              className="multiline"
            >
              {file.size ? formatBytes(file.size) : file.link_url || ""}
            </Typography>
          </Box>
        </Box>
        {false && (
          <IconButton onClick={() => removeFile(file)}>
            <CloseIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default ItemFile;
